import { postRequest } from '@/core';
import { edi } from '@/requests';

export default async function send(tripId) {
	let url = edi.scheduleEdiSendingTrip(tripId);
	await postRequest(url, {}, {});
}